"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalLink = exports.InternalLink = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_router_dom_1 = require("react-router-dom");
var storm_ui_1 = require("@amzn/storm-ui");
var StyledInternalLink = (0, styled_components_1.default)(react_router_dom_1.Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  font-size: ", ";\n  color: ", ";\n  text-decoration: none !important;\n\n  &:hover {\n    color: ", ";\n    text-decoration: underline;\n  }\n"], ["\n  margin: 0;\n  font-size: ", ";\n  color: ", ";\n  text-decoration: none !important;\n\n  &:hover {\n    color: ", ";\n    text-decoration: underline;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.size.base;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.auiblue;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.rust;
});
var combineUrlSearchParams = function (currentSearchParams, linkUrlSearchParams) {
    // Prioritizes key-values specified in the "to" InternalLink props over current search parameters
    currentSearchParams.forEach(function (value, key) {
        if (!linkUrlSearchParams.has(key)) {
            linkUrlSearchParams.append(key, value);
        }
    });
    return linkUrlSearchParams;
};
// See https://v5.reactrouter.com/web/api/Link for underlying link documentation
// The intention of InternalLink is to service inter-react app routing using React-Router
// The implementation biases for maintaining URL params of the current page in addition to those specified in the "to" prop
var InternalLink = function (props) {
    var linkToGeneric = props.to;
    var currentLocation = (0, react_router_dom_1.useLocation)();
    var currentSearchParams = new URLSearchParams(currentLocation.search);
    // ((location: Location) => LocationDescriptor) eg location => `${location.pathname}?sort=name` OR location => ({ ...location, pathname: "/courses" })
    if (typeof linkToGeneric === 'function') {
        // Resolve the function with current location to get a LocationDescriptor we can then manipulate
        var linkTo = linkToGeneric;
        linkToGeneric = linkTo(currentLocation);
    }
    // LocationDescriptor as Path string eg /courses?sort=name
    if (typeof linkToGeneric === 'string') {
        var linkTo = linkToGeneric;
        var linkUrl = new URL(linkTo, window.location.origin);
        var combinedUrlSearchParams = combineUrlSearchParams(currentSearchParams, linkUrl.searchParams);
        return react_1.default.createElement(StyledInternalLink, __assign({}, props, { to: { pathname: linkUrl.pathname, search: combinedUrlSearchParams.toString() } }));
    } // LocationDescriptor as LocationDescriptorObject eg { pathname: "/courses", search: "?sort=name", hash: "#the-hash", state: { fromDashboard: true } }
    else if (typeof linkToGeneric === 'object') {
        var linkTo = linkToGeneric;
        var combinedUrlSearchParams = combineUrlSearchParams(currentSearchParams, new URLSearchParams(linkTo.search));
        return react_1.default.createElement(StyledInternalLink, __assign({}, props, { to: __assign(__assign({}, linkTo), { search: combinedUrlSearchParams.toString() }) }));
    }
    return react_1.default.createElement(StyledInternalLink, __assign({}, props));
};
exports.InternalLink = InternalLink;
exports.ExternalLink = (0, styled_components_1.default)(storm_ui_1.Link).attrs(function (props) {
    var _a;
    return ({
        external: (_a = props.external) !== null && _a !== void 0 ? _a : true,
        target: '_blank',
        rel: 'noopener noreferrer',
        size: 'base',
    });
})(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2;
